import React, { Component } from 'react';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import Select2 from 'react-select2-wrapper';
import $ from 'jquery';
import { NavLink } from "react-router-dom";
import 'react-select2-wrapper/css/select2.css';
import moment from 'moment';
import FileDownload from 'js-file-download';
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import { Route, Redirect } from 'react-router'
import ApiError from './ApiError';
import Header from "./include/Header";
import {
  VEHICLE_ALL_BRANDS_VM,
  VEHICLE_MODELS_BY_BRAND_VM,
  VEHICLE_UPDATE_VARIANT_ID_VM,
  VEHICLE_MODELS_BY_BRAND_CARDEKHO,
  VEHICLE_MODELS_BY_MODEL_CARDEKHO,
  VEHICLE_MODELS_BY_VARIANT_CARDEKHO,
  FindUniqueData,
  date_filter_based_on_Mapping_status,
  VEHICLE_DATA_DOWNLOAD,
  unlink_file,
  LOGIN_TYPE_ADMIN,
  SERVICE20_TEXT,
  LOGIN_TYPE_USER,
  rc_prime_pdf_user_id
} from './helper/Constants';
import Apihelpers from './helper/ApiHelper';
var SelectYearOfRto=[];
class VariantMapping extends Component {
  state = {
    balanceCount: 0,
    vehicleBrands: [],
    vehicleBrandsCentralDb: [],
    manufacturingYears: [],
    currentYear: new Date().getFullYear(),
    brandSelected: '',
    brandSelectedCentralDb: '',
    variantIdSelected: '',
    variantIdCentralSelected: '',
    variantDetailCentral: [],
    vehicleModels: [],
    vehicleModelsforDefaultMapped: [],
    vehiclemodelsCentralDb: [],
    mappingCounts: [],
    mappingCountsNa: [],
    modelid: '',
    years: [],
    variantIdCentral: [],
    selectYear: '',
    variantid: '',
    centalSelectedBrandName: '',
    centalSelectedModelName: '',
    centalSelectedVariantName: '',
    mapping_comment: '',
    mapping_comment_list: [],
    mappig_Status_list: [],
    mapped_status: '',
    variant_mapping_visible: "",
    Total: 0,
    TotalMappeddata: 0,
    TotalUnmappeddata: 0,
    TotalCannotMappeddata: 0,
    TotalDefaultMappeddata:0,
    fromDate: '',
    toDate: '',
    MsgBoxText: '',
    successMsgColor: false,
    modelStartdateArray:[],
    modelEnddateArray:[],
    api_error:false,
    sourceType: 'prime',
    urlForBackButton:'',
    userId : ''
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {

    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
      this.setState({
        urlForBackButton:`${"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id")}`,
        userId : reactLocalStorage.get("login_user_id")
      });
      
    }
    //when admin login then for get price prime data using testing Qa data 
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.setState({
        userId: rc_prime_pdf_user_id,
        urlForBackButton:"/admin/client-list",
      });
    }


    setTimeout(function () {
      $("#mapping_fileter").select2('focus');
    }, 500);

    this.yearList();
    this.getCommentList();
    //this.uniquedata();
    this.getMappingList();
    $(document).ready(function () {
      $(".okBtn").click(function () {
        $(".customPopup").hide();
        $("#infoPopUp1 .textA").css("color","");
      });
    });
    this.setState({
      vehicleBrands: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
      vehicleModels: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
      vehicleBrandsCentralDb: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
      vehiclemodelsCentralDb: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
      variantIdCentral: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
      vehicleModelsforDefaultMapped: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }],
    });
    this.setState({
      brandSelected: -1,
      variantid: -1, //need
      variantIdCentralSelected: -1,
      brandSelectedCentralDb: -1,
      variantIdSelected: -1
    });
    let date_ob = new Date();
    let date = ("0" + (date_ob.getDate())).slice(-2);
    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    var todayDate = year + "-" + month + "-" + date;
    var formDate = todayDate + " 00:00:00";
    var toDate = todayDate + " 23:59:59";
    this.setState({
      fromDate: todayDate,
      toDate: todayDate
    });
    this.get_Filter_data_on_date_based(formDate, toDate);
  }
  uniquedata() {
    Apihelpers.getBrandList(FindUniqueData).then(res => {
    });
  }
  /**
   * Filter Section Start
   */
  filter = () => {
    const FromDate = this.state.fromDate;
    const toDate = this.state.toDate;
    let dayDiff = Math.abs(new Date(toDate) - new Date(FromDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (FromDate.length <= 0) {
      this.setState({ MsgBoxText: "Please Select Start date!!" });
      $("#infoPopUp1").show();
    }
    else if (toDate.length <= 0) {
      this.setState({ MsgBoxText: "Please Select End date!!" });
      $("#infoPopUp1").show();
    }
    else if (FromDate > toDate) {
      this.setState({ MsgBoxText: "Invaild Date Range!!" });
      $("#infoPopUp1").show();
    }
    else if (dayDiff > 31) {
      this.setState({ MsgBoxText: "Please select date range maximum 31 days" });
      $("#infoPopUp1").show();
    }
    else if (FromDate.length > 0 && toDate.length > 0) {
      let f = FromDate + " 00:00:00";
      let t = toDate + " 23:59:59";
      this.get_Filter_data_on_date_based(f, t);
      this.bindVehicleBrands(this.state.mapped_status);
      //this.get_Filter_data_on_date_based(FromDate, toDate);
    }
  }
  clearFilter = () => {
    //$("input[type=date]").val("");
    //this.get_Filter_data_on_date_based('', '');
    let date_ob = new Date();
    let date = ("0" + date_ob.getDate()).slice(-2);
    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    var todayDate = year + "-" + month + "-" + date;
    var formDate = todayDate + " 00:00:00";
    var toDate = todayDate + " 23:59:59";
    this.setState({
      fromDate: todayDate,
      toDate: todayDate
    });
    this.get_Filter_data_on_date_based(formDate, toDate);
    this.bindVehicleBrands(this.state.mapped_status);
  }
  get_Filter_data_on_date_based = (FromDate, toDate) => {
    $(".loader").show();
    const dates = {
      fromDate: FromDate,
      toDate: toDate,
      sourceType: this.state.sourceType
    };
    Apihelpers.get_Filter_data_on_date_based(date_filter_based_on_Mapping_status, dates).then(res => {
      this.setState({
        Total: res.data.data[0].Total,
        TotalMappeddata: res.data.data[0].mapped,
        TotalCannotMappeddata: res.data.data[0].cannotmapped,
        TotalUnmappeddata: res.data.data[0].unmapped
      });
      $(".loader").hide();
    });
  }
  /***
   * Filter Section End
   */

  /***
   * RTO Section Start
   */
  getMappingList() {
    this.setState({
      mappig_Status_list: [{ 'key': '0', 'id': '-1', 'text': 'Select' },
      {
        'key': '1', 'id': '1', 'text': 'Mapped'
      },
      {
        'key': '2', 'id': '0', 'text': 'Unmapped'
      },
      {
        'key': '3', 'id': '2', 'text': 'Can Not Mapped'
      }
      ]
    });
    this.setState({
      mapped_status: "0"
    });
  }
  // Get Brands/Make
  bindVehicleBrands(mappingstatus) {
    var formDate = this.state.fromDate;
    var toDate = this.state.toDate;
    let f = formDate + " 00:00:00";
    let t = toDate + " 23:59:59";
    this.setState({
      mapped_status: mappingstatus,
    });
    if (mappingstatus != -1) {
      $('.btnLoader_4').show();
      const data = {
        sourceType : this.state.sourceType,
        mapping_status: mappingstatus,
        FromDate: f,
        ToDate: t
      };
      Apihelpers.getdataresponse_variant_mapping(VEHICLE_ALL_BRANDS_VM, data).then(res => {
        console.log('on change mapping status',res);
        let brandData = res.data.data.map((brand, index) => {
          return { key: index, id: brand, text: brand }
        });
        this.setState({
          vehicleBrands: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }].concat(brandData),
          brandSelected: -1
        });
      });
      $('.btnLoader_4').hide();
    }
  }
  // Variants RTO
  bindVehicleModels() {
    if (this.state.mapped_status != -1) {
      $('.btnLoader_5').show();
    }
    const mapping_status = this.state.mapped_status;
    var formDate = this.state.fromDate;
    var toDate = this.state.toDate;
    let f = formDate + " 00:00:00";
    let t = toDate + " 23:59:59";
    const vehicleBrand = { vehicle_brand: this.state.brandSelected,sourceType: this.state.sourceType, mapping_status: mapping_status, FromDate: f, ToDate: t };
    Apihelpers.postdataresponse(VEHICLE_MODELS_BY_BRAND_VM, vehicleBrand).then(res => {
      let modelData = res.data.data.map((model, index) => {
        console.log(new Date(model.manufacturing_year));
        let vehicleModel = model.vehiclemodel + ' (' + model.manufacturing_year + ')';
        vehicleModel += model.variant_id != '' ? ' ------- ' + model.variant_id + '' : ' ------- Pending';
        let obj=new Object();
        obj["id"]=model._id;
        obj["year"]=model.manufacturing_year;
        SelectYearOfRto.push(obj);
        return { key: index, id: model._id, text: vehicleModel,variant_id:model.variant_id,modelId:model.modelId, year:model.year, makeId:model.makeId }
      });
      this.setState({
        vehicleModels: [{ 'key': '-1', 'id': '-1', 'text': 'Select' }].concat(modelData),
        vehicleModelsforDefaultMapped: [{ 'key': '-1', 'id': '-1', 'text': 'Select' }].concat(modelData),
        //vehicleModelsforDefaultMapped: res.data.data,
        variantIdSelected: -1
      });
      $('.btnLoader_5').hide();
    });
  }
  // RTO DB - ON CHANGE BRAND DROPDOWN
  loadVehicleModels(brandName) {
    this.setState({ brandSelected: brandName }, () => {
      this.bindVehicleModels();
    });
    this.setState({variantid: -1});
  }
  getSelectedVariantYear(data) {
    //console.log('calling change varent function');
    this.setState({variantIdSelected:data},()=>{
      var selected_year=SelectYearOfRto.find(({ id }) => id === data);
      if(selected_year!= undefined) {
        if (this.state.sourceType !== 'suggestion') {
          var y=new Date(selected_year["year"]);
          if(y!= "Invalid Date") {
            var year=y.getFullYear();
          } else{
            var year=(selected_year["year"].split("/"))[1];
          }
          this.GetBrandList(year);
        } else {
          var varientObj = this.state.vehicleModelsforDefaultMapped.filter((obj)=>{
            if (obj.id === data) {
              return obj;
            }
          });
          console.log('varientObj',varientObj);
          this.setState({
            selectYear: varientObj[0].year,
            brandSelectedCentralDb: varientObj[0].makeId,
            variantIdCentralSelected: varientObj[0].modelId
          })
          //this.GetBrandList(varientObj[0].year);
          
          setTimeout(() => {
           //alert('year: '+this.state.selectYear+', Brand/makeId: '+this.state.brandSelectedCentralDb+', modal(variantIdCentralSelected): '+this.state.variantIdCentralSelected+', varient id: '+varientObj[0].variant_id);
            setTimeout(() => {
              this.setState({ variantid: varientObj[0].variant_id });
            }, 600);
            //need
            this.bindVehicleBrandsAPI();
            this.bindVehicleBrandModelsAPI();
            this.bindVehicleBrandModelVariantAPI();
            //this.variantInfo(this.state.variantid); 
          }, 200);
        }

      } else{
        this.GetBrandList(data);
      }

      
    });
  }
  // getVariantDataOwnDB(data)
  // {
  // }
  /***
   * RTO Section End
   */

  /***
     * Centerl Section start
     */
  getYearDropList = () => {
    let year = new Date().getFullYear();
    var yearList = [];
    while (year >= 1980) {
      yearList.push(year);
      year = year - 1;
    }
    return yearList;
  };
  yearList() {
    var year = this.getYearDropList();
    let yearList = year.map((y, index) => {
      return { key: index, id: y, text: y }
    });
    this.setState({
      years: [{ 'key': '-1', 'id': '-1', 'text': 'Select' }].concat(yearList)
    });
    this.setState({ selectYear: -1 });


  }
  async bindVehicleBrandsAPI() {
    if (this.state.selectYear != -1) {
      $('.btnLoader_1').show();
    } else {
      return
    }
    var RTOSelectedBrand=this.state.brandSelected;
    console.log("Rto selected brand==========", RTOSelectedBrand)
    var centarlBrand=-1;
    const vehicleYear = { year: this.state.selectYear , userid : this.state.userId };
    console.log("insidevehicleyear=====", vehicleYear)
    //alert('calling brand list api..'+vehicleYear.year);
    await Apihelpers.getBrandList(VEHICLE_MODELS_BY_BRAND_CARDEKHO, vehicleYear).then(res => {
      console.log("brand resposne==========", res)
      if(res.data.status==false && this.state.selectYear != -1){
        this.setState({api_error:true});

        return;
      }

      let brandData = res.data.data.map((brand, index) => {
        let brand_name_in_upper_case=brand.brand.toUpperCase();
        // debugger;
        //console.log("inside brandname=======", brand_name_in_upper_case)
        RTOSelectedBrand = RTOSelectedBrand.toString()
        try {
          if(RTOSelectedBrand.includes(brand_name_in_upper_case) === true) {
            centarlBrand=brand.index;
          }
          return { key: brand.index, id: brand.index, text: brand.brand }
        } catch (error) {
          console.log("inside catch==========", error)
          if (error) {
            console.log("RTOSelectedBrand-------",RTOSelectedBrand)
            console.log("Type of RTOSelectedBrand-------", typeof RTOSelectedBrand)
            console.log("brand_name_in_upper_case-----",brand_name_in_upper_case)
            //window.location = "../admin/api-error";

          }


        }

      });
      this.setState({
        vehicleBrandsCentralDb: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }].concat(brandData),
        //brandSelectedCentralDb:centarlBrand
        variantid: -1
      });
      if (this.state.sourceType !== 'suggestion') {
        //this.setState({brandSelectedCentralDb:centarlBrand});
      }
      $('.btnLoader_1').hide();
    });
    if(this.state.api_error)
    {
      window.location="../admin/api-error";   
    }
  }
  async bindVehicleBrandModelsAPI() {
    if (this.state.brandSelectedCentralDb != -1) {
      $('.btnLoader_2').show();
    } else {
      return
    }
    const vehicleBrand = {
      vehicle_brand: this.state.brandSelectedCentralDb,
      year: this.state.selectYear,
      userid : this.state.userId
    };
    let variantDetailTemp = [];
    var startDateArray=[];
    var endDateArray=[];
    //alert('calling modal list api...'+vehicleBrand.vehicle_brand);
    await Apihelpers.getBrandModelsList(VEHICLE_MODELS_BY_MODEL_CARDEKHO, vehicleBrand).
      then(res => {
        if(res.data.status==false  && this.state.brandSelectedCentralDb != -1 && this.state.selectYear != -1){
          this.setState({api_error:true});
          return;
        }
        let modelData = res.data.data.map((model, index) => {
          startDateArray[model.modelId]=model.startDate;
          endDateArray[model.modelId]=model.endDate;
          return { key: index, id: model.modelId, text: model.displayName }
        });
        this.setState({
          vehiclemodelsCentralDb: [{ 'key': '-1', 'id': '-1', 'text': 'Select' }].concat(modelData),
          //variantIdCentralSelected: -1,
          modelStartdateArray: startDateArray,
          modelEnddateArray: endDateArray,
          variantid: -1 //need
        });
        if (this.state.sourceType !== 'suggestion') {
          this.setState({variantIdCentralSelected: -1});
        }
        $('.btnLoader_2').hide();
      });
    if(this.state.api_error)
    {
      window.location="../admin/api-error";
    }
  }
  async bindVehicleBrandModelVariantAPI() {
    if (this.state.variantIdCentralSelected != -1) {
      $('.btnLoader_3').show();
    }
    const vehicle_Model = {
      vehicle_model: this.state.variantIdCentralSelected,
      year: this.state.selectYear
    };
    var result=await Apihelpers.getVariantList(VEHICLE_MODELS_BY_VARIANT_CARDEKHO, vehicle_Model).then(res => {
      if(res.data.status===false && this.state.variantIdCentralSelected != -1 && this.state.selectYear != -1){
        this.setState({api_error:true});
        return;
      }
      let variantDetailTemp = [];
      let variantData = res.data.data.map((variant, index) => {
        variantDetailTemp[variant.variantId] = { data: variant };//need
        return { key: index, id: variant.variantId, text: variant.name + " (" + variant.fuel + ")" }
      });
      this.setState({ variantDetailCentral: variantDetailTemp });
      this.setState({
        variantIdCentral: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }].concat(variantData),
        //variantid: -1
      });
      if (this.state.sourceType !== 'suggestion') {
        this.setState({ variantid: -1 });//need
      } else {
        this.variantInfo(this.state.variantid);
      }
      //console.log('varient list get from api',variantData)
      $('.btnLoader_3').hide();
    });
    if(this.state.api_error)
    {
      window.location="../admin/api-error";
    }

  }

  GetBrandList(year) {
    this.setState({ selectYear: year }, () => {
      this.setState({ vehicleBrandsCentralDb: [{ 'key': '0000', 'id': '-1', 'text': 'Select' }] });
      this.setState({ brandSelectedCentralDb: -1, variantIdCentralSelected: -1  });
      if (year != (-1)) {
        this.bindVehicleBrandsAPI();
      }
    })
  }
  // CENTRAL DB - BIND ALL VARIANTS
  loadVehicleModelsCentralDb(brandName) {
    this.setState({ brandSelectedCentralDb: brandName }, () => {
      this.bindVehicleBrandModelsAPI();
    });
  }
  loadVehicleModelsVariantFromAPI(modelId) {
    this.setState({ variantIdCentralSelected: modelId }, () => {
      this.bindVehicleBrandModelVariantAPI();
    })
  }
  variantInfo(variantid) {
    this.setState({ variantid: variantid });//need
    // var div = document.getElementById("variantInfoId");
    // if (variantid > 0) {
    //   div.style.display = "block";
    // }
    // else {
    //   div.style.display = "none";
    // }
  }
  /***
   * Central Section End
   */


  /***
   * Mapping, Can'nt mapping or comment Section start
   */
  getCommentList() {
    this.setState({
      mapping_comment_list: [{ 'key': '0', 'id': '', 'text': 'Select Comment' },
      {
        'key': '1', 'id': 'Two Whealer', 'text': 'Two Whealer'
      },
      {
        'key': '2', 'id': 'Three Whealer', 'text': 'Three Whealer'
      },
      {
        'key': '3', 'id': 'Model Name Not Identified', 'text': 'Model Name Not Identified'
      },
      {
        'key': '4', 'id': 'Commercial Vehicles', 'text': 'Commercial Vehicles'
      }
      ]
    });
    this.setState({
      mapping_comment: ""
    });
  }
  updateVariantId = (event) => {
    const variantIdSelected = this.state.variantIdSelected;
    const variantIdCentralSelected = this.state.variantid;
    const year = this.state.selectYear;
    const brand = this.state.brandSelectedCentralDb;
    const model = this.state.variantIdCentralSelected;
    const variant = variantIdCentralSelected;
    const RTOBrand = this.state.brandSelected;
    const RTOVariant = this.state.variantIdSelected;
    
    //getting central value 
    let actualBrandName = "";
    let actualModelName = "";
    let actualVariantName = "";
    if (this.state.variantDetailCentral[this.state.variantid]) {
      actualBrandName = this.state.variantDetailCentral[this.state.variantid].data.brandName;
      actualModelName = this.state.variantDetailCentral[this.state.variantid].data.modelName;
      actualVariantName = this.state.variantDetailCentral[this.state.variantid].data.variantName;
    } else {
      actualBrandName = this.state.variantDetailCentral[this.state.variantIdCentral];
      actualModelName = this.state.variantDetailCentral[this.state.variantIdCentral];
      actualVariantName = this.state.variantDetailCentral[this.state.variantIdCentral];
    }

    if (year == -1 || brand == -1 || model == -1 || variant == -1 || RTOBrand == -1 || RTOVariant == -1) {
      if (RTOBrand <= 0) {
        this.setState({ MsgBoxText: "Please Select RTO Brand!!" });
        $("#infoPopUp1").show();
      }
      else if (RTOVariant <= 0) {
        this.setState({ MsgBoxText: "Please Select RTO variant!!" });
        $("#infoPopUp1").show();
      }
      else if (year == -1) {
        this.setState({ MsgBoxText: "Please Select Central Year!!" });
        $("#infoPopUp1").show();
      }
      else if (brand == -1) {
        this.setState({ MsgBoxText: "Please Select Central Brand!!" });
        $("#infoPopUp1").show();
      }
      else if (model == -1) {
        this.setState({ MsgBoxText: "Please Select Central model!!" });
        $("#infoPopUp1").show();
      }
      else if (variant == -1) {
        this.setState({ MsgBoxText: "Please Select Central Variant!!" });
        $("#infoPopUp1").show();
      }
    }
    else {
      const variant_ids = {
        rto_variant_id: variantIdSelected,
        central_variant_id: variantIdCentralSelected,
        mapping_status: 1,
        not_mapping_comment: "",
        modelId:model,
        makeId:brand,
        bbUserId : this.state.userId,
        centralBrandName: actualBrandName,
        centralModelName: actualModelName,
        centralVariantName: actualVariantName
      };

      Apihelpers.postdataresponse(VEHICLE_UPDATE_VARIANT_ID_VM, variant_ids)
        .then(res => {
          if (res.data.status == true) {
            var formDate = this.state.fromDate;
            var toDate = this.state.toDate;
            let f = formDate + " 00:00:00";
            let t = toDate + " 23:59:59";
            this.bindVehicleModels();
            this.get_Filter_data_on_date_based(f, t);
            this.setState({ MsgBoxText: "Mapped Successfully." });
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","green");
            this.setState({
              brandSelected: -1,
              variantid: -1,//need
              variantIdCentralSelected: -1,
              brandSelectedCentralDb: -1,
              variantIdSelected: -1,
              //mapped_status: -1,
              selectYear: -1
            });
            $("#variantInfoId").hide();
          } else {
            this.setState({ MsgBoxText: "Someting went wrong." });
            $("#infoPopUp1").show();
          }
        });
    }
  }
  ConnotMapped = (event) => {
    const variantIdSelected = this.state.variantIdSelected;
    const RTOBrand = this.state.brandSelected;
    const RTOVariant = this.state.variantIdSelected;
    if (RTOBrand.length <= 0 || RTOVariant.length <= 0) {
      if (RTOBrand <= 0) {
        this.setState({ MsgBoxText: "Please Select RTO Brand!!" });
        $("#infoPopUp1").show();
        this.setState({
          brandSelected: -1,
          variantid: -1,//need
          variantIdCentralSelected: -1,
          brandSelectedCentralDb: -1,
          variantIdSelected: -1,
          mapped_status: -1,
          selectYear: -1

        });
        $("#variantInfoId").hide();
      }
      else if (RTOVariant <= 0) {
        this.setState({ MsgBoxText: "Please Select RTO variant!!" });
        $("#infoPopUp1").show();
      }
    }
    else {
      const variantIdCentralSelected = this.state.variantid;//need
      const mapping_comment = this.state.mapping_comment;
      if (mapping_comment.length == 0) {
        this.setState({ MsgBoxText: "Please Select Appropriate Comment." });
        $("#infoPopUp1").show();
      }
      else {
        var variant_ids = {
          rto_variant_id: variantIdSelected,
          central_variant_id: 0,
          mapping_status: 2,
          not_mapping_comment: mapping_comment,
          modelId:"0",
          makeId:"0",
          bbUserId : this.state.userId,
          centralBrandName: '',
          centralModelName: '',
          centralVariantName: ''
        };
        //if select sourct type
        if (this.state.sourceType === 'suggestion') {
          variant_ids = {
            rto_variant_id: variantIdSelected,
            mapping_status: 2,
            not_mapping_comment: mapping_comment,
            bbUserId : this.state.userId
          };
        }
        
        Apihelpers.postdataresponse(VEHICLE_UPDATE_VARIANT_ID_VM, variant_ids)
          .then(res => {
            if (res.data.status == true) {
              var formDate = this.state.fromDate;
              var toDate = this.state.toDate;
              let f = formDate + " 00:00:00";
              let t = toDate + " 23:59:59";
              this.bindVehicleModels();
              this.get_Filter_data_on_date_based(f,t);
              this.setState({ MsgBoxText: "Mark to can'nt Mapped." });
              $("#infoPopUp1").show();
              $("#variantInfoId").hide();
            } else {
              this.setState({ MsgBoxText: "Someting went wrong." });
              $("#infoPopUp1").show();
            }
          });
      }
    }
  }
  /***
 * Mapping, Can'nt mapping or comment Section start
 */
  /***
   * Download Report start
   */
  createAndDownloadPdf = () => {
    this.filter();
    let FromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let dayDiff = Math.abs(new Date(toDate) - new Date(FromDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    if (FromDate.length <= 0) {
      this.setState({ MsgBoxText: "Please Select Start date!!" });
      $("#infoPopUp1").show();
    }
    else if (toDate.length <= 0) {
      this.setState({ MsgBoxText: "Please Select End date!!" });
      $("#infoPopUp1").show();
    }
    else if (FromDate > toDate) {
      this.setState({ MsgBoxText: "Invaild Date Range!!" });
      $("#infoPopUp1").show();
    }
    else if (dayDiff > 15) {
      this.setState({ MsgBoxText: "Please select date range maximum 15 days" });
      $("#infoPopUp1").show();
    }
    else if (FromDate.length > 0 && toDate.length > 0) {
      let from = moment(FromDate, 'YYYY/M/D');
      var to = moment(toDate, 'YYYY/M/D');
      var diffDays = to.diff(from, 'days');
      if (diffDays <= 30) {
        let f = FromDate + " 00:00:00";
        let t = toDate + " 23:59:59";
        const data = {
          fromDate: FromDate + " 00:00:00",
          toDate: toDate + " 23:59:59",
          file_name: "variant_mapping_report_" +FromDate + "to" + toDate + ".csv",
          sourceType: this.state.sourceType
        };
        $(".downloadNow").attr("disabled", true);
        Apihelpers.createAndDownloadPdf(VEHICLE_DATA_DOWNLOAD,data).then(res => {
          if (res.status == 201) {
            if(res.data.data> 0){
              var fileName = data.file_name;
              Apihelpers.downloadFileresponse("export-report/" + fileName).then(res => {
                FileDownload(res.data, fileName);
                setTimeout( ()=>{ 
              const detlete_file_path = { "filepath": "/reportgeneratedExcel/" + fileName ,isFullPath:true};
              Apihelpers.postdataresponse(unlink_file, detlete_file_path);
              
            }, 7000);
              }).catch((err) => {
                console.log(err);
              });
            }else{
              this.setState({ MsgBoxText: "Data not Found." });
              $("#infoPopUp1").show();
            }
            setTimeout( ()=>{ 
            $(".downloadNow").attr("disabled", false);
            }, 4000);
          } else {
            this.setState({ MsgBoxText: "Somethink went wrong." });
            $("#infoPopUp1").show();
          }
        })

      }
      else 
      {
        this.setState({ MsgBoxText: "Please select Start Date & End Date in between 30 days." });
        $("#infoPopUp1").show();
      }
    }
  }
  /**
   * Download Report End
   */
  render() {
  if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_api_variant_mapping_service") === SERVICE20_TEXT) {
    return (
      <div className="wrapper">
        <Header />
        {/*<header className="header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-auto">
                <div className="logo">
                  <a ><img src="/assets/images/logo.png" alt="" /></a>
                </div>
              </div>
              <div className="col">
                <div className="headerRight">
                  <div className="filterBlock">
                    <div style={{ float: "right" }}>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>*/}
        <div className="container">
          <div className="whiteBox variantPage">
            <div className="titleRow">
              <div className="row">
                <div className="col">
                  <h3 className="title">Variant Mapping</h3>
                </div>
                <div className="col">
                      <NavLink
                        to={this.state.urlForBackButton}
                        exact
                        style={{ float: "right", fontSize: "13px", color: "#1a73e8", textDecoration: "none" }}
                      >  <i className="fa fa-arrow-left"></i> Back</NavLink>
                    </div>
              </div>
            </div>
            <div className="mapFilterRow">
              <div className="row">
                <div className="col">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="control-title">Source</label>
                        <select className="form-control" value={this.state.sourceType} onChange={(e)=>this.setState({sourceType:e.target.value})} tabIndex="1">
                          <option value="prime">Prime</option>
                          <option value="suggestion">Suggestion</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="control-title">Mapping Status</label>
                        <Select2
                          data={this.state.mappig_Status_list}
                          style={{
                            width: '100%',
                          }}
                          id="mapping_fileter"
                          value={this.state.mapped_status}
                          onChange={(e) => this.bindVehicleBrands(e.target.value)}
                          className="form-control"
                          name="mapping_fileter"
                          tabIndex="1"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="control-title">Start Date</label>
                        <input className="form-control" id="startDate" value={this.state.fromDate} placeholder="Start Date" type="date" tabIndex="-1"
                          onChange={(e) => this.setState({ fromDate: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="control-title" >End Date</label>
                        <input className="form-control" id="endDate" tabIndex="-1" value={this.state.toDate} placeholder="End Date" type="date"
                          onChange={(e) => this.setState({ toDate: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="btnRow">
                    <button className="yellowBtn" type="button" tabIndex="-1" onClick={this.filter}>Apply</button>
                    <button className="borderBtn" type="button" tabIndex="-1" onClick={this.clearFilter}>Reset</button>
                    <button className="blueBtn downloadNow" type="button" tabIndex="-1" onClick={this.createAndDownloadPdf}>Download</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="mapedCountRow">
              <div className="row">
                <div className="col-md-3">
                  <div className="block">
                    <h4>Total: <span className="count">{this.state.Total}</span></h4>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="block">
                    <h4>Unmapped: <span className="count">{this.state.TotalUnmappeddata}</span></h4>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="block">
                    <h4>Mapped: <span className="count">{this.state.TotalMappeddata}</span></h4>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="block">
                    <h4>Can Not Be Mapped: <span className="count">{this.state.TotalCannotMappeddata}</span></h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 rtoMapBlock">
                <div className="mapFilter">
                  <h3 className="heading"><span>RTO</span></h3>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="control-title">Brand</label>
                        <div className="dropDownLoader">
                          <i className="btnLoader btnLoader_5"></i>
                          <Select2
                            data={this.state.vehicleBrands}
                            id="vehicle_brand"
                            value={this.state.brandSelected}
                            onChange={(e) => this.loadVehicleModels(e.target.value)}
                            className="form-control"
                            name="vehicle_brand"
                            tabIndex="2"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="control-title">Variant</label>
                        <div className="dropDownLoader">
                          <i className="btnLoader btnLoader_4"></i>
                          <Select2
                            data={this.state.vehicleModels}
                            style={{
                              width: '100%',
                            }}
                            id="vehicle_variants"
                            value={this.state.variantIdSelected}
                            onChange={(e) => this.getSelectedVariantYear(e.target.value)}
                            className="form-control"
                            name="vehicle_variant"
                            tabIndex="3"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 apiMapBlock">
                <div className="mapFilter">
                  <h3 className="heading"><span>Central</span></h3>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-title">Year</label>
                        <Select2
                          data={this.state.years}
                          id="vehicle_year"
                          value={this.state.selectYear}
                          onSelect={(e) => this.GetBrandList(e.target.value)}
                          className="form-control"
                          name="vehicle_year"
                          tabIndex="4"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-title">Brand</label>
                        <div className="dropDownLoader">
                          <i className="btnLoader btnLoader_1"></i>
                          <Select2
                            data={this.state.vehicleBrandsCentralDb}
                            //id="vehicle_brands_central"
                            value={this.state.brandSelectedCentralDb}
                            onSelect={(e) => {
                              this.loadVehicleModelsCentralDb(e.target.value)
                            }}
                            className="form-control"
                            //name="vehicle_brand_central"
                            tabIndex="5"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-title">Model</label>
                        <div className="dropDownLoader">
                          <i className="btnLoader btnLoader_2"></i>
                          <Select2
                            data={this.state.vehiclemodelsCentralDb}
                            id="vehicle_variant_central"
                            value={this.state.variantIdCentralSelected}
                            onSelect={(e) => this.loadVehicleModelsVariantFromAPI(e.target.value)}
                            className="form-control"
                            name="vehicle_variant_central"
                            tabIndex="6"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-title">Variant</label>
                        <div className="dropDownLoader">
                          <i className="btnLoader btnLoader_3"></i>
                          <Select2
                            data={this.state.variantIdCentral}
                            id="vehicle_variants_central"
                            value={this.state.variantid}//need
                            onSelect={(e) => 
                              //this.variantInfo(e.target.value)
                              this.setState({ variantid: e.target.value })
                            }
                            className="form-control"
                            name="vehicle_variants_central"
                            tabIndex="7"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="varintInfoBlock" id="variantInfoId" style={(this.state.variantid > 0) ? {display:'block'} : {display:'none'}}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="infoRow">
                          <div className="key">Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.displayName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Variant Id: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.variantId : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Variant Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.name : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Model Id: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.modelId : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Model Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.modelDisplayName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Model Start: </div>
                          <div className="val">{this.state.modelStartdateArray[this.state.variantIdCentralSelected]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Model End: </div>
                          <div className="val">{this.state.modelEnddateArray[this.state.variantIdCentralSelected]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Oem Id: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.oemId : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Oem Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.oemName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Transmission Type: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.transmissionType : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Fuel:</div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.fuel : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Status: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.status : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Displacement: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.displacement : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Brand Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.brandName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Model Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.modelName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="infoRow">
                          <div className="key">Variant Name: </div>
                          <div className="val">{this.state.variantDetailCentral[this.state.variantid] ? this.state.variantDetailCentral[this.state.variantid].data.variantName : this.state.variantDetailCentral[this.state.variantIdCentral]}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-md-12">
                <div className="mapBtnsRow">
                  <button type="button" className="yellowBtn" tabIndex="8" onClick={this.updateVariantId}>Map</button>
                  <div className="commentInput">
                    <Select2
                      data={this.state.mapping_comment_list}
                      id="mapping_comment"
                      value={this.state.mapping_comment}
                      className="form-control"
                      onChange={(e) => this.setState({ mapping_comment: e.target.value })}
                      name="mapping_comment"
                      tabIndex="9"
                    />
                  </div>
                  <button type="button" className="borderBtn" tabIndex="10" onClick={this.ConnotMapped}>Can't Map</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="customPopup" id="infoPopUp1">
          <div className="bgLayer"></div>
          <div className="popUpBox">
            <div className="popScroll">
              <div className="infoMessagePopUp">
                <div className="textA">{this.state.MsgBoxText}</div>
                <div className="submitRow">
                  <button className="blueBtn okBtn" tabIndex="5" type="button">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="loader" style={{ display: "none" }}>
          <div className="bg"></div>
          <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
        </div>
      </div>
    );
  }
  else {
    return (
      <UnAuthorised></UnAuthorised>
    )
  }
 }
}
export default VariantMapping;
